import React from 'react';
import Helmet from 'react-helmet';

import SpotWorkersStore from '../services/spotWorkers/SpotWorkersStore';
import SpotWorkersContext from '../services/spotWorkers/SpotWorkersContext';

import InfinityScrollLoad from '../components/InfinityScrollLoad';
import SpotWorkersHeader from '../components/header/SpotWorkersHeader';
import { SearchForm } from '../components/searchmenus/SpotWorkersSearch';
import { SpotWorkersTable } from '../components/tables/SpotWorkersTable';
import Information from '../components/modals/common/Information';

import { messageUtility } from '../utilities/messageUtility';
import { SPOT_WORKER_RESIDENCE_TYPE } from '../utilities/constants';

import Styles from '../styles/componentStyle/spotWorkers/spotWorkers.scss';

/**
 * 現場常駐社員・非常駐入退場者一覧画面
 */
const SpotWorkers = ({ spotWorkerType, pageTitle }) => {
  return (
    <SpotWorkersStore spotWorkerType={spotWorkerType}>
      <SpotWorkersContext.Consumer>
        {({ state, infiniteScrollLoad, closeNotExistFieldIdDialog }) => (
          <React.Fragment>
            <div id='main' className={`${Styles.main} main`}>
              <Helmet title={pageTitle} />
              <div className='main__header'>
                <h1>{pageTitle}</h1>
              </div>

              <div id='infinityscroll-target' className='main__body'>
                <SpotWorkersHeader spotWorkerType={spotWorkerType} />
                <SearchForm spotWorkerType={spotWorkerType} />
                <SpotWorkersTable
                  spotWorkerType={spotWorkerType}
                  isVisibleThumbnails={state.isVisibleThumbnails}
                />

                <InfinityScrollLoad
                  targetId='infinityscroll-target'
                  total={state.searchForm.total}
                  reset={state.canLoadMore}
                  callback={notify => {
                    infiniteScrollLoad(notify);
                  }}
                />
              </div>
            </div>
            <Information
              message={messageUtility.getMessage('E-002-001-006')}
              buttonText={messageUtility.getMessage('I-000-017')}
              visible={state.isShowNotExistFieldIdDialog}
              onClose={() => closeNotExistFieldIdDialog()}
            />
          </React.Fragment>
        )}
      </SpotWorkersContext.Consumer>
    </SpotWorkersStore>
  );
};

/**
 * 現場常駐社員一覧画面
 */
export const ResidentSpotWorkers = () => (
  <SpotWorkers
    spotWorkerType={SPOT_WORKER_RESIDENCE_TYPE.RESIDENT}
    pageTitle={data.residentPageTitle}
  />
);

/**
 * 非常駐入退場者一覧画面
 */
export const NonResidentSpotWorkers = () => (
  <SpotWorkers
    spotWorkerType={SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT}
    pageTitle={data.nonResidentPageTitle}
  />
);

// 定数
const data = {
  residentPageTitle: '現場常駐社員一覧',
  nonResidentPageTitle: '非常駐入退場者一覧',
};



// WEBPACK FOOTER //
// ./src/pages/SpotWorkers.jsx